<template>
  <div class="authority" >
    <el-row class="m-con">
      <el-col :span="20">
        <el-tabs v-model="activeName" @tab-click="handleTabsClick">
          <el-tab-pane label="会员搜索记录" name="show">
            <div v-if="!active_role" class="node-empty"><p>暂无数据</p></div>
            <div class="node-con" v-else>
             <div><el-button type="primary" size="mini" @click="$router.go(-1)" style="float:right;margin-bottom: 10px;">返回</el-button></div>
                <el-table
                  max-height="650"
                  :data="keywordData"
                  style="width: 100%; margin-top: 10px"
                  border
                  size="mini"
                  :header-cell-style="{
                    background: '#ecf4ff',
                    color: '#333',
                    fontWeight: '900',
                    fontSize: '0.28rem',
                  }"
                >
              <el-table-column prop="id" label="ID"> </el-table-column>
              <el-table-column prop="username.name" label="用户名称"></el-table-column>
              <el-table-column prop="keyword" label="关键字"></el-table-column>
              <el-table-column prop="source" label="来源" width="50"></el-table-column>
              <el-table-column prop="location" label="访问位置"></el-table-column>
              <el-table-column prop="number" label="次数"></el-table-column>
              <el-table-column prop="search_at" label="时间"></el-table-column>
            </el-table>
            <div class="block" style="margin-top: 10px; text-align: right">
              <el-pagination
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                layout="sizes, total, prev, pager, next, jumper"
                :total="total"
                :page-sizes="[10, 15, 30, 50, 100]"
                :page-size="pageSize"
                background
              >
              </el-pagination>
            </div>
          </div>
          </el-tab-pane>
          <el-tab-pane label="会员访问记录" name="post">
            <div v-if="!active_role" class="node-empty"><p>暂无数据</p></div>
            <div class="node-con" v-else>
            <div>
              <el-button type="primary" size="mini" @click="$router.go(-1)" style="float:right;margin-bottom: 10px;">返回</el-button>
            </div>
            <el-table
              max-height="650"
              :data="visitedDAta"
              style="width: 100%; margin-top: 10px"
              border
              size="mini"
              :header-cell-style="{
                background: '#ecf4ff',
                color: '#333',
                fontWeight: '900',
                fontSize: '0.28rem',
              }"
            >
              <el-table-column prop="id" label="ID" width="80"> </el-table-column>
              <el-table-column prop="username.name" label="用户名称"></el-table-column>
              <el-table-column prop="method" label="请求方式"></el-table-column>
              <el-table-column prop="source" label="来源" width="50"></el-table-column>
              <el-table-column prop="page_name" label="请求的页面"></el-table-column>
              <el-table-column prop="url" label="请求地址"></el-table-column>
              <el-table-column prop="num" label="数量"></el-table-column>
              <el-table-column prop="created_at" label="时间"></el-table-column>
              <el-table-column prop="ip" label="IP"></el-table-column>
              <el-table-column prop="input" label="参数"></el-table-column>
            </el-table>
            <div class="block" style="margin-top: 10px; text-align: right">
                  <el-pagination
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  layout="sizes, total, prev, pager, next, jumper"
                  :total="total"
                  :page-sizes="[10, 15, 30, 50, 100]"
                  :page-size="pageSize"
                  background
                >
                </el-pagination>
            </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'Searchaccess',
  data () {
    return {

      page: 1,
      pageSize: 10,
      total: 0,
      activeName: 'show',
      active_role: true,
      keywordData: [],
      visitedDAta: [],
      uid: ''
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
    '$route': 'gettingData'
  },
  created () {
    this.gettingData()
  },
  mounted () {
    this.getRoles()
  },
  methods: {
    gettingData () {
      this.uid = this.$route.query.uid
    },
    getRoles () {
      this.$axios.get('/api/admin/customer/searchaccess', {
        params: {
          page: this.page,
          pageSize: this.pageSize,
          uid: this.uid
        }
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.keywordData = data.data.keyword.data
            this.total = data.data.keyword.total
            this.visitedDAta = data.data.visited.data
            this.total = data.data.visited.total
          }
        })
    },
    handleCurrentChange (val) {
      this.page = val
      this.getRoles()
    },
    handleSizeChange (val) {
      this.pagesize = val
      this.getRoles()
    },
    handleTabsClick (tab, event) {
      this.page = 1
      this.getRoles()
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .authority >>> .el-tabs__header
    padding-left: .4rem
  .authority >>> .el-tabs__nav-wrap::after
    display:none !important
  .el-checkbox.is-bordered
    margin-bottom: .2rem
  .authority
    marginLeft()
    .m-con
      background-color: #fff
      border-radius: .2rem .2rem 0 0
    .mtb30
      margin-bottom: .6rem
    .mt10
      margin-top: .2rem
    .pb15
      padding-bottom: .3rem
    .role-list
      min-height: calc(100vh - 210px)
      padding-right: 12px
      border-right: 1px solid #ebebeb
      .list
        margin-top: .3rem
    .more-icon
      float: right
      color: #5789F4
      cursor: pointer
    .sel-role
      cursor: pointer
    .active-role
      color: #5789f4
    .node-header
      line-height: .88rem
      padding-left: .4rem
      margin-bottom: .3rem
      color: #5789F4
    .node-empty
      text-align: center
      color: rgba(0, 0, 0, .3)
    .node-con
      padding-left: .4rem
    .check-title
      margin-right: .4rem
    .tr
      text-align: right
    .el-checkbox.is-bordered+.el-checkbox.is-bordered
      margin-left: 0
     .el-col-20{
      width :100%
     }
</style>



// WEBPACK FOOTER //
// src/pages/my_customers/search_access.vue